import React from 'react';

import JourneyViewContent from 'src/common/JourneyViewContent';
import VideoPlayer from 'src/VideoPlayer';

import { isRawVideo } from 'src/utils/journey';
import { Creator } from 'src/common/interfaces/creator.interface';
import { Content } from 'src/common/interfaces/content.interface';
import { Node } from 'src/common/interfaces/node.interface';
import { Nullable } from 'src/types/nullable.type';
import { Journey } from 'src/common/interfaces/journey.interface';

export const EditContentFormContentPreview = ({
  content,
  journey,
  creator,
  brandingColor,
  isMobileForced,
}: {
  content: Content | Node;
  journey?: Nullable<Journey>;
  creator?: Creator;
  brandingColor?: any;
  isMobileForced?: any;
}) => {
  if (!content) return null;

  if (isRawVideo(content)) {
    return (
      <VideoPlayer 
        showPlayer={true} 
        autoplay={false} 
        currentNode={content} 
        isMobileForced={isMobileForced} 
      />
    );
  } else {
    return (
      <JourneyViewContent 
        content={content}
        journey={journey}
        autoplay={false} 
        canEdit={true} 
        brandingColor={brandingColor} 
      />
    );
  }
};
